import { fetchUtils } from 'react-admin';
import { getTokens } from '@/src/auth/FirebaseAuth';

const API_ACCESS_TOKEN_HEADER = 'AUTHORIZATION';

export const COUNT_HEADER_NAME = 'X-Total-Count';
const BASE_URL = import.meta.env.VITE_URL;

export const httpClient = async (url: string, options: any = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: 'application/json' });
  }

  // add your own headers here
  const tokens = await getTokens();
  if (tokens?.token) {
    options.headers.set(API_ACCESS_TOKEN_HEADER, `Bearer ${tokens?.token}`);
    options.headers.set('ngrok-skip-browser-warning', '69420');
  }

  return fetchUtils.fetchJson(`${BASE_URL}${url}`, options).then((res) => {
    if (Array.isArray(res.json)) {
      const overrideHeaders = new Headers(res.headers);
      overrideHeaders.set(COUNT_HEADER_NAME, `${res.json.length}`);
      return {
        ...res,
        headers: overrideHeaders,
      };
    }
    return res;
  });
};
